<button kendoButton (click)="this.startEditing()">{{'Hdw Config' | translate: 'Hdw Config'}}</button>
@if (this.isEditing) {
<kendo-dialog title="{{'Hardware Configuratie' | translate: 'Hardware Configuratie'}}" width="80%" maxHeight="80%" (close)="this.isEditing = false">
    @let _system = this.editSystem.system();
    @if (_system == undefined) {
    <kendo-dropdownbutton [data]="this.hdwMetaService.meta().mainBoards" [textField]="'label'"
        (itemClick)="this.onMainboard($event)">
        {{'Computertype' | translate: 'Computertype'}}
    </kendo-dropdownbutton>
    } @else {
    <div class="system">
        <div class="buttonbar">
            @if (this.editDipSwitches) {
                <button kendoButton (click)="this.onCancelEditDipSwitch()">{{'Cancel' | translate: 'Cancel'}}</button>
                <button kendoButton (click)="this.onSaveDipSwitch()" [themeColor]="'primary'">{{'Bewerken' | translate: 'Bewerken'}}</button>
            } @else {
                <button kendoButton (click)="this.onMainboard(undefined)">{{'Reset' | translate: 'Reset'}}</button>
                <button kendoButton (click)="this.onStartEditDipSwitch()" [themeColor]="'primary'">{{'DipSwitches Bewerken' | translate: 'DipSwitches Bewerken'}}</button>

            }
            @if (this.jsBridgeService.isDev()) {
                <translation-editor />
            }
        </div>

        <div class="mainboard">
            <div>Mainboard: {{_system.mainboard.label}}</div>
            <div>
                <ioview [ios]="_system.getIOs()"></ioview>
            </div>
        </div>
        @let busTypes = _system.getBusTypes();
        @for (busType of busTypes; track busType) {
            @let racks = _system.getRacks(busType);
            @for (rack of racks; track $index) {
                <rack-view [rack]="rack" [editDipSwitch]="this.editDipSwitches"></rack-view>
            }
        }
        <div>

            <button kendoButton (click)="this.addRack()">{{'Add Rack' | translate: 'Add Rack'}}</button>
        </div>
    </div>
    }

    <kendo-dialog-actions>
        <button kendoButton (click)="this.isEditing = false">{{'Close' | translate: 'Close'}}</button>
        <button kendoButton (click)="this.save()" [themeColor]="'primary'">{{'Save' | translate: 'Save'}}</button>
        </kendo-dialog-actions>
</kendo-dialog>
}